import React from 'react'
import { Box, Button, Tooltip } from '@material-ui/core'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import clsx from 'clsx'

import { WhiteTooltip } from 'components'

import DaiStarIcon from '../StarIcon/StarIcon'

import useStyles from './styles'
import palette from 'theme/palette'
import { grey } from '@material-ui/core/colors'

const StarButton = ({
  children,
  size = 'medium',
  variant = 'contained',
  disabled = false,
  disabledTooltipTitle,
  automaticWidth = false,
  aiAlert = false,
  tooltipProps = {},
  ...rest
}) => {
  const classes = useStyles()

  const isOutlined = variant === 'outlined'

  const iconColor = disabled ? grey[500] : palette.dai.shinyBlue

  const iconSize = {
    small: 16,
    medium: 20,
    large: 24,
  }

  const showDisabledTooltip = disabled && !isEmpty(disabledTooltipTitle)

  const button = (
    <Box
      className={clsx({ [classes.automaticWidthButtonBox]: automaticWidth })}
    >
      <Button
        variant={variant}
        size={size}
        startIcon={<DaiStarIcon size={iconSize[size]} color={iconColor} />}
        className={clsx({
          [classes.root]: !isOutlined,
          [classes.outlined]: isOutlined,
        })}
        disabled={disabled}
        {...rest}
      >
        {children}
      </Button>
    </Box>
  )

  if (showDisabledTooltip)
    return <Tooltip title={disabledTooltipTitle}>{button}</Tooltip>

  if (aiAlert)
    return (
      <WhiteTooltip aiAlert {...tooltipProps}>
        {button}
      </WhiteTooltip>
    )

  return button
}

StarButton.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  variant: PropTypes.oneOf(['contained', 'outlined']),
  aiAlert: PropTypes.bool,
}

export default StarButton
